/* @flow */

export { WeakMap } from './weakmap';



// WEBPACK FOOTER //
// ./~/cross-domain-safe-weakmap/src/interface.js